import useSelector from '@app/hooks/useSelector';

import { getCustomStatuses } from '../../../../reducers/downloadData/selectors';
import type { CustomTranslationStatusId } from '../../../../types';
import CustomStatusInput from './CustomStatusInput';
import type { Option } from './types';

const prepareValue = (value: readonly CustomTranslationStatusId[], options: readonly Option[]): readonly Option[] =>
    value
        .map((id) => options.find((item) => item.value === id) ?? null)
        .filter((item): item is Option => item !== null);

interface CustomStatusInputContainerProps {
    value: readonly CustomTranslationStatusId[];
    onChange: (value: readonly CustomTranslationStatusId[]) => void;
}

const CustomStatusInputContainer = ({ value, onChange }: CustomStatusInputContainerProps) => {
    const customStatuses = useSelector(getCustomStatuses);

    const options = customStatuses.map(({ id, title }) => ({ value: id, label: title }));

    return (
        <CustomStatusInput
            value={prepareValue(value, options)}
            options={options}
            onChange={(val) => onChange(val.map((item) => item.value))}
        />
    );
};

export default CustomStatusInputContainer;
